import { useMemo } from "react";
import { PartyPopper, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../data";
import { useLang } from "../i18n";

const FESTIVALS = [
  { key: "janmashtami", date: new Date("2026-09-04T00:00:00"), hindi: "जन्माष्टमी" },
  { key: "holi", date: new Date("2027-03-22T00:00:00"), hindi: "होली" },
];

export const FestivalBanner = () => {
  const { s } = useLang();
  const fest = useMemo(() => {
    const now = new Date();
    return FESTIVALS.find((f) => f.date >= now) || null;
  }, []);

  if (!fest) return null;
  const days = Math.ceil((fest.date.getTime() - Date.now()) / 86400000);
  if (days > 120) return null;

  return (
    <section className="relative overflow-hidden bg-saffron" data-testid="festival-banner">
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute -right-4 top-1/2 -translate-y-1/2 font-hindi text-[14vw] leading-none text-night/[0.06]"
      >
        {fest.hindi}
      </span>
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
        <Reveal>
          <p className="flex items-center gap-2 text-xs uppercase tracking-[0.25em] font-bold text-night/70" data-testid="festival-overline">
            <PartyPopper size={16} /> {s.banner.overline}
          </p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-black text-night tracking-tight max-w-2xl" data-testid="festival-heading">
            {s.banner.heading[fest.key]}
          </h2>
          <p className="mt-3 max-w-xl text-sm sm:text-base font-medium leading-relaxed text-night/75" data-testid="festival-text">
            {s.banner.text[fest.key]}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex flex-col items-start lg:items-end gap-4">
            <div className="rounded-2xl bg-night px-6 py-4 text-center" data-testid="festival-countdown">
              <p className="font-display text-4xl font-black text-saffron leading-none">{days}</p>
              <p className="mt-1 text-xs font-semibold uppercase tracking-widest text-cream/70">
                {s.banner.daysLeft}
              </p>
            </div>
            <a
              href={waLink("Namaste! I want to book a room at Shri Jamuna Dham for the festival season. Please share availability and tariff.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="festival-book-button"
              className="inline-flex items-center gap-2 rounded-full bg-night px-7 py-3.5 text-sm font-bold text-saffron transition-colors duration-300 hover:bg-maroon hover:text-cream"
            >
              <MessageCircle size={16} /> {s.banner.cta}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
